module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/main_img_02-3-c35c539e9b3ce01d0dd897dbca36ead5.png";